import React, {useState} from "react";
import { useEffect } from "react";
import { connect } from "react-redux";

import stateMap from "store/stateMap";

import { popinfo } from "component/Fancybox/Fancybox";
import api from "api";

const ComponentDisallowEmail = connect(stateMap) (props => {
    const [allowEmail, setAllowEmail]   = useState(false);
    const [isLoading, setIsLoading]         = useState(true);

    const ToggleAllowEmail = (e) => {
        if(!props.auth.user)
        {
            return;
        }
        
        setAllowEmail(!allowEmail);

        api('/Config/DisallowEmail', 'post', {
            disallow_email : e.target.checked
        }, 'Bearer ' + props.auth.token)
            .then(response => {
                setAllowEmail(response.is_disallowed);
            })
            .catch(error => {
                popinfo('error', 'Allow Email', error);
            })

        
    }

    useEffect(() => {
        if(!props.auth.user)
        {
            return
        }

        setIsLoading(true);

        api('/Config/DisallowEmail', 'get', {}, 'Bearer ' + props.auth.token)
            .then(response => {
                setIsLoading(false);
                setAllowEmail(response.is_disallowed);
            })
            .catch(error => {
                setIsLoading(false);
                popinfo('error', 'Retrieving Allow Email Config.', error);
            })


    }, [props.auth.user])

    return (
        isLoading ? <span className="skeleton"></span> :    
        <label className="switch-button">
            <input 
                type="checkbox"
                checked={allowEmail == 1}
                onChange={ToggleAllowEmail}
            />
            <span className="slider round"></span>
        </label>
    )
});

export { ComponentDisallowEmail }